import { render } from "./TopBarComponent.vue?vue&type=template&id=f5dce4dc"
import script from "./TopBarComponent.vue?vue&type=script&lang=js"
export * from "./TopBarComponent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__